import { Component, Element, h, Host, Prop } from '@stencil/core';
import { INDICATOR_DIRECTIONS, IndicatorDirection } from '../../../../models/directions.types';
import { BUTTON_SIZES, ButtonSize } from '../../../button/models/button.types';

@Component({
  tag: 'wink-indicator',
  styleUrl: 'styles/indicator.default.scss',
})
export class Indicator {
  @Element() host!: HTMLWinkIndicatorElement;

  @Prop() direction: IndicatorDirection = INDICATOR_DIRECTIONS.right;
  @Prop() size: ButtonSize = BUTTON_SIZES.sm;
  @Prop() isDisabled = false;
  @Prop() indicatorAriaLabel?: string;

  private readonly iconsNamesMap = new Map([
    [INDICATOR_DIRECTIONS.left, 'chevron-left-small'],
    [INDICATOR_DIRECTIONS.right, 'chevron-right-small'],
    [INDICATOR_DIRECTIONS.up, 'chevron-up-small'],
    [INDICATOR_DIRECTIONS.down, 'chevron-down-small'],
  ]);

  private getClass() {
    return {
      indicator: true,
      'is-disabled': this.isDisabled,
    };
  }

  private getAttributes() {
    return {
      disabled: this.isDisabled,
      ...(this.indicatorAriaLabel ? { 'aria-label': this.indicatorAriaLabel } : {}),
    };
  }

  render() {
    return (
      <Host>
        <div class="wrapper">
          <button class={this.getClass()} {...this.getAttributes()}>
            <wink-icon appearance="default" size={this.size} icon={this.iconsNamesMap.get(this.direction)}></wink-icon>
          </button>
        </div>
      </Host>
    );
  }
}
